import { z } from 'zod';
import { platformRoleSchema } from './organizations.js';
export const meResponseSchema = z.object({
    user: z.object({
        id: z.string(),
        name: z.string(),
        email: z.string(),
        emailVerified: z.boolean(),
    }),
    platformRoles: z.array(platformRoleSchema),
    /** null = persoonlijke modus (of de actieve club is niet meer geldig). */
    activeOrganizationId: z.string().nullable(),
});
//# sourceMappingURL=me.js.map